import { Calendar, MapPin } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { SiteFooter } from "@/components/SiteFooter";
import { PublicHeader } from "@/components/PublicHeader";
import { EventSlider } from "@/components/EventSlider";
import { SponsorsCarousel } from "@/components/SponsorsCarousel";
import { useApp } from "@/context/AppContext";
import { cedi, minFee } from "@/lib/api";

export default function Home() {
  const { events } = useApp();
  const nav = useNavigate();
  const register = (e) => nav(`/event-registration?event=${e.id}`);
  const ordered = [...events].sort((a, b) => Number(b.featured) - Number(a.featured));
  return (
    <div className="min-h-screen bg-[#F8F9FA]" data-testid="home-page">
      <PublicHeader />
      <main className="max-w-7xl mx-auto px-4 sm:px-8 py-8">
        <div className="text-sm sm:text-[23px] leading-tight font-heading font-extrabold uppercase tracking-[0.08em] text-[#E60000] mb-5" data-testid="home-org-name">Ghana Association of Medical Laboratory Scientists</div>
        <EventSlider events={ordered} onRegister={register} />
        <h2 className="font-heading text-2xl font-extrabold tracking-tight mt-12 mb-4">All upcoming events</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {ordered.map((e) => (
            <button key={e.id} onClick={() => register(e)} className="text-left flex flex-col bg-white border border-[#E5E7EB] rounded-lg overflow-hidden hover:border-[#E60000] transition-colors" data-testid={`home-event-card-${e.id}`}>
              <img src={e.image} alt={e.title} className="h-40 w-full object-cover" />
              <div className="p-5">
                <div className="font-heading font-bold leading-snug">{e.title}</div>
                <div className="text-sm text-gray-600 mt-2 flex items-center gap-1.5"><Calendar className="w-4 h-4" />{e.date}</div>
                <div className="text-sm text-gray-600 flex items-center gap-1.5"><MapPin className="w-4 h-4" />{e.venue}</div>
                <div className="font-heading font-extrabold mt-3">From {cedi(minFee(e))}</div>
              </div>
            </button>
          ))}
        </div>
      </main>
      <SponsorsCarousel />
      <SiteFooter />
    </div>
  );
}
